import React from 'react';

const AttendanceCard = ({ streakData, lastAttendanceText, monthlyCountText }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">출석</h2>
        <span className="text-xs text-muted-foreground caption">마지막 출석: {lastAttendanceText}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
        <div className="rounded-md bg-muted/40 border border-border px-3 py-2">
          <div className="text-xs text-muted-foreground caption">현재 연속</div>
          <div className="text-lg font-bold text-foreground data-text">{streakData?.currentStreak}일</div>
        </div>
        <div className="rounded-md bg-muted/40 border border-border px-3 py-2">
          <div className="text-xs text-muted-foreground caption">최장 연속</div>
          <div className="text-lg font-bold text-foreground data-text">{streakData?.longestStreak}일</div>
        </div>
        <div className="rounded-md bg-muted/40 border border-border px-3 py-2">
          <div className="text-xs text-muted-foreground caption">이번달 출석</div>
          <div className="text-lg font-bold text-foreground data-text">{monthlyCountText}</div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceCard;
